<template>
  <div class="d-flex flex-column">
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="top-header d-flex flex-row align-center justify-space-between">
      <div class="d-flex flex-row align-center">
        <router-link :to="{ name: 'manufacturers_list' }">
          <v-btn icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </router-link>
        <span>Create Manufacturer</span>
      </div>
    </div>

    <v-sheet class="mt-2">
      <v-form class="main-form pa-3" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="$t('Name')"
                v-model="name"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex flex-row align-center justify-end">
            <v-btn
              class="text-capitalize white--text"
              color="primary"
              tile
              depressed
              @click="createBrand()"
            >
              <img
                class="mr-1"
                width="28px"
                height="28px"
                src="/icons/plus.svg"
              />
              {{ $t("Create") }}
            </v-btn>
          </div>
        </v-container>
      </v-form>
    </v-sheet>
  </div>
</template>
<script>
import RestResourceAuth from "@/api/apiAuthService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import RestResourceBrand from "../../api/apiBrandService";
import RestResourceManufacturer from "../../api/apiManufacturerService";

export default {
  name: "NewAccount",
  data() {
    return {
      creating: false,
      errorAlert: false,
      errorMsg: "",
      name: "",
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        },
        pass: v => v.length >= 8 || this.$t("errors.shortPassword")
      }
    };
  },
  computed: {
    passwordMatch() {
      return () =>
        this.admin.password === this.admin.password1 ||
        this.$t("errors.passMustMatch");
    }
  },
  methods: {
    createBrand() {
      if (this.$refs.form.validate()) {
        this.creating = true;
        RestResourceManufacturer.prototype
          .postManufacturer({ name: this.name })
          .then(() => {
            this.$router.push({ name: "manufacturers_list" });
          })
          .catch(error => {
            this.errorMsg = error.response.data.message;
            this.errorAlert = true;
            this.creating = false;
          })
          .finally(() => {
            this.creating = false;
          });
      }
    }
  }
};
</script>
<style></style>
